import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useApiFetcher } from "../ApiProvider";
import { QUERY_KEYS } from "../queryKeys";
export interface MissedOpportunity {
  activity: string;
  /** Always positive: what was forgone, not a penalty applied. */
  points: number;
}
export interface SessionMissedOpportunitiesResponse {
  items: MissedOpportunity[];
  totalPoints: number;
}

/**
 * What a finished session could have scored and did not.
 *
 * A session's history does not change once it has ended, so this is cached for
 * the life of the tab rather than re-fetched — the completion dialog is often
 * reopened, and the answer is the same every time.
 */
export function useSessionMissedOpportunities(sessionId, options) {
  const $ = _c(9);
  const apiFetcher = useApiFetcher();
  let t0;
  if ($[0] !== sessionId) {
    t0 = QUERY_KEYS.sessionMissedOpportunities(sessionId ?? "");
    $[0] = sessionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== apiFetcher || $[3] !== sessionId) {
    t1 = () => apiFetcher(`/api/v1/sessions/productivity/${sessionId}/missed`);
    $[2] = apiFetcher;
    $[3] = sessionId;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = Boolean(sessionId) && (options?.enabled ?? true);
  let t3;
  if ($[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      staleTime: Infinity,
      gcTime: 3600000
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return useQuery(t3);
}